module.exports = __webpack_public_path__ + "img/bg2.cd0840fc.jpg";